import { gql } from "@apollo/client";

export const CREATE_REPORT = gql`
  mutation ($input: genrateReportInput) {
    genrateReport(input: $input)
  }
`;
